import { T } from 'ramda';
import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setLogoExpanding';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  logoExpanded: () => 1,
  logoExpandedAction: () => 1,
  immediate: T,
});

export const action = {
  [name]: fn,
};

export default action;
